/**
* 左边菜单
*/ 
<template>
  <div class="menu">
    <div class="information">
      <img :src="headPic"/>
      <p class="name">{{userName}}</p>
      <p class="id">账户ID：{{ userId }}</p> 
      <p class="authentication" v-if="!realName">尚未实名认证<span @click="onForward" style="margin-left: 20px;">前往认证</span></p>
      <p class="authentication" v-else><span style="margin: 20px;">已认证</span></p>
    </div>
    <div class="menus">
      <el-menu 
        :default-active="activeMenu" 
        class="el-menu-vertical-demo" 
        :unique-opened="true"
        active-text-color="#ff821e"
        
        >
        <el-menu-item v-for="item in menuList" :key="item.id" :index="item.url">
          <router-link class="router_title" :to="item.url">{{item.name}}</router-link>
        </el-menu-item>
      </el-menu>
    </div>
    <el-button class="button" type="warning" @click="exit" style="background-color: #ff821c">退出登录</el-button>
    
  </div>
  
</template>
<script>
import { userInfo } from '../api/userMG'
export default {
  name: 'leftnav',
  data() {
    return {
      menuList: [],
      activeMenu:'/personal/personal',
      userName:localStorage.getItem('username'),
      userId:localStorage.getItem('id'),
      headPic:localStorage.getItem('headPic'),
      realName:localStorage.getItem('realName')
    }
  },
  computed: {
    url() {
      return this.$store.getters.url;
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.getUserInfo()
    // 在组件创建时设置默认高亮的菜单项
    this.activeMenu = this.$route.path;
    this.$emit('getName',this.$route.name)
    // 添加路由监听器以更新高亮项
    this.$router.afterEach((to, from) => {
      this.activeMenu = to.path;
      this.$emit('getName',this.$route.name)
    });

    let res = {
      success: true,
      data: [
        {
          id: 1,
          // icon: 'li-icon-xiangmuguanli',
          name: '个人资料',
          hasThird: null,
          url: '/personal/personal',
        },
        {
          id: 2,
          name: '我的报名',
          hasThird: null,
          url: '/enroll/enroll',
        },
        {
          id: 3,
          name: '我的考试',
          hasThird: null,
          url: '/exam/exam',
        },
        {
          id: 4,
          name: '我的课程',
          hasThird: null,
          url: '/course/course',
        },
        {
          id: 5,
          name: '我的证书',
          hasThird: null,
          url: '/certificate/certificate',
        },
        {
          id: 6,
          name: '我的收藏',
          hasThird: null,
          url: '/collect/collect',
        },
        {
          id: 7,
          name: '我的订单',
          hasThird: null,
          url: '/order/order',
        },
        {
          id: 8,
          name: '我的优惠券',
          hasThird: null,
          url: '/coupon/coupon',
        },
        {
          id: 9,
          name: '我的发票',
          hasThird: null,
          url: '/invoice/invoice',
        },
        {
          id: 10,
          name: '账号管理',
          hasThird: null,
          url: '/manage/manage',
        }
      ],
      msg: 'success'
    }
    this.menuList = res.data
  },
  methods:{
    async getUserInfo(){
      await userInfo().then(res => {
        this.realName = res.data.realName;
      })
    },
    // keyPath
    exit(){
      this.$confirm('此操作退出当前登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '退出成功!',
          offset:100
        });
        setTimeout(() => {
          localStorage.clear();
          this.$router.push({path:'/index/index'})
        }, 1500);
      }).catch(() => {
               
      });
    },
    onForward(){
      this.$emit('forward')
    },
    
  },
}
</script>
<style scoped>
.information{
  text-align: center;
  padding: 30px 0 14px;
  background-image: linear-gradient(bottom,#fff,#fff8f2);
  border: 1px solid #e2e2e4;
  border-bottom: none;
  border-radius: 8px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.information img{
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin-bottom: 4px;
}
.information .name{
  font-size: 14px;
  margin-bottom: 10px;
  text-align: center;
}
.information .id{
  font-size: 12px;
  color: #949293;
  text-align: center;
}
.information .authentication{
  text-align: center;
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 13px;
  color: #666666;
  line-height: 32px;
  border-bottom: 1px solid #E5E5E4;
  margin: 0 12px;
  padding-bottom: 4px;
}
.information .authentication span{
  text-align: center;
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 13px;
  color: #F25902;
  cursor: pointer;
}
.menus{
  background: #fff;
  padding: 0 12px 20px; 
  border: 1px solid #e2e2e4;
  border-top: none;
  border-bottom: none;
  /* border-radius: 8px;
  border-top-left-radius: 0;
  border-top-right-radius: 0; */
}
.menus ul li{
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 16px 0 20px;
  cursor: pointer;
}
.menus ul li p{
  font-size: 13px;
}
.menus ul li img{
  width: 5px;
}
.menus ul .is-active{
  background: #fff2e9 !important;
}
.menus ul .is-active .router_title{
  color: #FF821E;
}
.menus .el-menu{
  border-right: none;
}
.menus .el-menu-item span{
  font-size: 13px;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-item.is-active{
  background: #fff2e9;
}
.el-menu-item:hover{
  background: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}
.logoimg {
  height: 40px;
}
.button{
  width: 100%;
  height: 50px;
}
.menus .el-menu-item{
  height: 50px;
  line-height: 50px;
}
.menus /deep/ .el-menu-item:focus{
  background: none
}
.router_title{
  font-size: 13px;
  color: #333;
  text-decoration: none;
  width: 100%;
}
.router_title:hover{
  color: #ff821c;
}
/* .el-message-box__btns {
  display: flex;
  justify-content: flex-end;
}
.el-button{
    margin: unset ;
} */

</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue